module.exports = __webpack_public_path__ + "img/zuyanaxi.e4de7a33.jpg";